import { createTheme, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications, notifications } from '@mantine/notifications';
import { ApiRuntimeService } from '@newo/api-client';
import { appConfig } from '@newo/app-config';
import { Language, LocalizationService } from '@newo/localization';
import { AppId, routingClient } from '@newo/routing-client';
import { storage } from '@newo/storage';
import { getTheme } from '@newo/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import App from '@/App.tsx';
import { runtimeConfig } from '@/constants';
import { partnerMetadata } from '@/services/PartnerMetadata';
import AppV2 from '@/srcV2/App.tsx';
import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.css';
import './index.css';
const queryClient = new QueryClient();
const run = async () => {
	const root = document.getElementById('root');

	if (!root) {
		console.error('#root elem is not found, rendering aborted');
		return;
	}

	appConfig.initializeFromRuntime();

	ApiRuntimeService.init({
		apiHost: runtimeConfig.apiHostEndpoint,
		chatApiHost: runtimeConfig.chatApiEndpoint,
		storage,

		onError: (status, reason) => {
			notifications.show({
				'data-testid': 'api-error-notification',
				color: 'red',
				title: status,
				message: reason,
				autoClose: 2000
			});
		}
	});
	await partnerMetadata.initialize();

	routingClient.bootstrap({
		apps: [{ appId: AppId.Creator, isHost: true }],
		externalAppOrigins: {
			[AppId.Portal]: runtimeConfig.whiteLabelPortalUrl
		}
	});

	LocalizationService.init({
		isEnabled: partnerMetadata.isLocalizationEnabled(),
		tenant: partnerMetadata.getId(),
		// TODO move this to cms control level
		disabledLanguages: [
			...(partnerMetadata.isItalianLocalizationDisabled() ? [Language.It] : [])
		]
	});

	const theme = createTheme(getTheme(partnerMetadata.getTheme()));

	createRoot(root).render(
		<routingClient.Provider>
			<MantineProvider theme={theme}>
				<Notifications
					autoClose={5000}
					limit={5}
					position="bottom-left"
				/>
				<ModalsProvider>
					<QueryClientProvider client={queryClient}>
						{partnerMetadata.isVibeCreatorFlowEnabled() ? <AppV2 /> : <App />}
					</QueryClientProvider>
				</ModalsProvider>
			</MantineProvider>
		</routingClient.Provider>
	);
};

void run();
